module.exports = __webpack_public_path__ + "img/logo_oAuth.9f7363f3.svg";